<template>

    <ul class="breadcrumbs">
        <li v-for="crumb in breadcrumbs">
            <router-link :to="crumb.link">{{crumb.title}}</router-link>
        </li>
    </ul>
</template>

<script>

export default {
    // TODO: remove this, it's from the old forum.

    props: ['breadcrumbs'],
    data() {
        return {

        }
    }
}

</script>


<style lang="scss" scoped>
li {
    float: left;
    margin-right: 2rem;
    padding: 1rem 0;
    &::after {
        content: '\00BB';
        position: relative;
        right: -1rem;
        color:#33ccff;

    }
    &:last-child {
        font-weight:600;
        &::after {
            display:none;
        }
    }
}

a {
    color: white;
}
</style>



// WEBPACK FOOTER //
// ForumBreadcrumbs.vue?210470c9